/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { Button, Text } from "@itwin/itwinui-react";
import { MarkdownRenderer } from "../markdown-renderer/MarkdownRenderer";
import styles from "./Readme.module.css";

export interface ReadmeProps {
  content?: string;
  readOnly?: boolean;
  onCreateReadme?: () => void;
}

export const Readme = ({ content, readOnly, onCreateReadme }: ReadmeProps) => {

  // const linkOptions = useMemo(() => ({
  //   overrides: {
  //     a: createLinkOverride({
  //       linkTypes: [
  //         {
  //           filter: (href) => !/^https?:/gi.test(href) && (/^\/[a-z0-9]+\/.*/gi.test(href)),
  //           component: SandboxLink,
  //           props: {
  //             onClick: async (username: string | null, sandboxName: string | null, fileSelection?: { file: string, start?: number, end?: number }) => {
  //               if (username && sandboxName) {
  //                 const args: any = [username, sandboxName];
  //                 if (fileSelection) {
  //                   const { file, ...selection } = fileSelection;
  //                   args.push(file);
  //                   args.push(selection);
  //                 }
  //                 const { pathname } = RouteManager.routeTo("codeshare", ...args) as { pathname: string };
  //                 window.open(pathname);
  //               }
  //             },
  //             onError: (error: SandboxError) => {
  //               toaster.warning(error.message, { hasCloseButton: true });
  //             },
  //           },
  //         },
  //         {
  //           filter: (href) => !/^https?:/gi.test(href) && (/\.\.\/.+\/[a-z0-9.?=]+$/i.test(href) || /\.\/[a-z0-9.?=]+$/i.test(href)),
  //           component: RelativeLink,
  //           props: {
  //             onClick: async (sandboxName: string | null, fileSelection?: { file: string, start?: number, end?: number }) => {
  //               if (sandboxName && sandbox) {
  //                 const args: any = [sandbox.username, sandboxName];
  //                 if (fileSelection) {
  //                   const { file, ...selection } = fileSelection;
  //                   args.push(file);
  //                   args.push(selection);
  //                 }
  //                 const { pathname } = RouteManager.routeTo("codeshare", ...args) as { pathname: string };
  //                 window.open(pathname);
  //               } else if (fileSelection) {
  //                 activityActions.setActive(fileSelection.file, fileSelection.start ? { startLineNumber: fileSelection.start, endLineNumber: fileSelection.end ? fileSelection.end : fileSelection.start + 1, startColumn: 1, endColumn: 1 } : undefined);
  //               }
  //             },
  //             onError: (error: SandboxError) => {
  //               toaster.warning(error.message, { hasCloseButton: true });
  //             },
  //           },
  //         },
  //         {
  //           filter: (href) => /^https?:/gi.test(href),
  //           component: ExternalLink,
  //           props: {},
  //         },
  //       ],
  //     }),
  //   },
  // }), [activityActions, sandbox]);

  if (content === undefined) {
    if (readOnly) {
      return (
        <div className={styles.readmeCentered}>
          <div className={styles.message}>
            <Text variant="subheading">No overview to display</Text>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.readmeCentered}>
          <div className={styles.message}>
            <Text variant="subheading">No overview to display</Text>
            <Text>You can create your own for this sandbox!</Text>
            <Button as="a" className="iui-anchor" styleType="borderless" onClick={onCreateReadme}>Create an overview</Button>
          </div>
        </div>
      );
    }
  }

  if (content !== undefined && content.length === 0) {
    return (
      <div className={styles.readmeCentered}>
        <div className={styles.message}>
          <Text variant="subheading">Overview has no content</Text>
          {!readOnly && <Text>Add content to the readme.md file for it to display here</Text>}
        </div>
      </div>
    );
  }

  return (
    <MarkdownRenderer>
      {content}
    </MarkdownRenderer>
  );
};
